import { render, staticRenderFns } from "./gateinpass.vue?vue&type=template&id=63fd714f&scoped=true&"
import script from "./gateinpass.vue?vue&type=script&lang=js&"
export * from "./gateinpass.vue?vue&type=script&lang=js&"
import style0 from "./gateinpass.vue?vue&type=style&index=0&id=63fd714f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fd714f",
  null
  
)

export default component.exports